import App from './popularAccountsHolder.vue'
import appInit from "../shared/app-init"

appInit(App, "#popularAccountsHolder", true);